import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import i18n from 'i18next';
import "./index.css";

import closeIconMobile from "../../../../../assets/imgs/icons/closeIconMobile.svg";
import search from "../../../../../assets/imgs/icons/group50.png";
import { switchLanguage } from "../../../../../config/commonUtil";
import Accordion from "../Accordion";
import TextPanel from "../TextPanel";
import { useTranslation } from "react-i18next";
import online from "../../../../../assets/imgs/icons/online.png";
import { getLink } from '../../../utils';

const Mobile = ({
  menus = [],
  loginMenu = {},
  onClose,
  openSearch,
  visible,
}) => {
  const [show, setShow] = useState(visible);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    setShow(visible);
  }, [visible]);

  const handleClose = () => {
    onClose && onClose();
  };

  const handleSearch = () => {
    openSearch && openSearch();
  };

  const handleChangeLanguage = () => {
    const pathname = window.location.pathname.replace(i18n.language, i18n.language === "ch" ? "en" : "ch");
    navigate(pathname, { replace: true });
    i18n.changeLanguage(i18n.language === "ch" ? "en" : "ch");

    // let url = window.location.href;
    // window.location.replace(switchLanguage(url));
  };

  const processArry = (children) => {
    let resultArray = [];
    let arrayA = [];
    let arrayB = [];
    for (let i = 0; i < children.length; i++) {
      let item = children[i];
      if ((i + 1) % 2 === 0) {
        arrayB.push(item);
      } else {
        arrayA.push(item);
      }
    }
    resultArray = [...arrayA, ...arrayB];
    return resultArray;
  };

  return (
    <div className="bx-header-mobile" data-visible={show}>
      <div className="bx-header-mobile-scroll">
        <div className="bx-header-mobile-close" onClick={handleClose}>
          <img
            className="close-icon"
            src={closeIconMobile}
            alt="mobile close icon"
          />
        </div>
        <div className="bx-header-mobile-main">
          <a href={getLink(loginMenu?.href)}>
            <div className="title">{loginMenu?.indexText}</div>
          </a>
          {/* <div className="search" onClick={handleSearch}>
            <img src={search} />
          </div> */}
        </div>
        {menus.map((item) => (
          <Accordion
            key={item.value}
            title={item.label}
            className={"menu"}
            lock={!(item.children && item.children.length > 0)}
            href={item.href}
            children={
              <div className="menu-content">
                {item.type === "single" ? (
                  <TextPanel
                    subMenus={[...item.children[0], ...item.children[1]]}
                  />
                ) : (
                  item &&
                  item.children &&
                  item.children.map((subItem) => (
                    <Accordion
                      key={subItem.value}
                      title={subItem.label}
                      children={
                        <>
                          <TextPanel subMenus={processArry(subItem.children)} />
                          {subItem.onLine && (
                            <div className="text-tips">
                              <img className="text-tips-icon" src={online} />
                              <span className="text-tips-title">
                                {subItem.onLine.label}
                              </span>
                            </div>
                          )}
                        </>
                      }
                    />
                  ))
                )}
              </div>
            }
          />
        ))}
        <Accordion
          title={loginMenu.label}
          foldState={loginMenu.unfold}
          className={"menu"}
          lock
          children={<TextPanel subMenus={loginMenu.children} />}
        />
        <div className="bx-header-mobile-footer">
          <span
            className="bx-header-mobile-lang"
            onClick={handleChangeLanguage}
          >
            {" "}
            {t("translation:home.header.lang")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Mobile;
